import React, { ReactNode } from 'react';

interface FloatingBulkActionsContainerProps {
  /**
   * Whether the container should be visible
   */
  isVisible: boolean;

  /**
   * The action buttons to display in the container
   */
  children: ReactNode;

  /**
   * Optional z-index for the container
   */
  zIndex?: number;
}

/**
 * A floating container for bulk action buttons that appears at the bottom of the viewport
 * when items are selected.
 */
export const FloatingBulkActionsContainer: React.FC<
  FloatingBulkActionsContainerProps
> = ({ isVisible, children, zIndex = 10 }) => {
  return (
    <div
      className={`dark:bg-base-100 fixed bottom-6 left-1/2 flex -translate-x-1/2 transform gap-1 rounded-lg border border-gray-400 bg-white p-1 shadow-xl shadow-gray-500/30 transition-all duration-300 ease-in-out dark:border-gray-800 dark:shadow-gray-900/30 ${
        isVisible
          ? 'translate-y-0 opacity-100'
          : 'pointer-events-none translate-y-8 opacity-0'
      }`}
      style={{ zIndex }}
      aria-hidden={!isVisible}>
      {children}
    </div>
  );
};
